import React, { useState, useEffect } from 'react';
import { ROLES } from '../utils/roles';
import './ContactModal.css';

// De opdaterede roller
const AVAILABLE_ROLES = [
  'Prøveansvarlig',
  'Kontaktperson',
  'Portalansvarlig',
  'Souschef',
  'Administrativ medarbejder',
  'Forstander',
  'Modultestansvarlig'
];

const ContactModal = ({ contact, isOpen, onClose, onSave, onDelete, user, centers }) => {
  
  const defaultScId = user.role === ROLES.SC_ADMIN ? user.scId : '';
  
  const [formData, setFormData] = useState({
    navn: '',
    email: '',
    telefon: '',
    sprogcenter_id: defaultScId
  });

  // State til de valgte roller (Array)
  const [selectedRoles, setSelectedRoles] = useState([]);

  useEffect(() => {
    if (contact) {
      setFormData({
        navn: contact.navn || '',
        email: contact.email || '',
        telefon: contact.telefon || '',
        sprogcenter_id: contact.sprogcenter_id || defaultScId
      });
      // Sæt roller (håndter at gamle data måske kommer som string hvis DB ikke var migreret, men nu er det array)
      // Vi sikrer os at det altid er et array
      const roles = Array.isArray(contact.rolle) ? contact.rolle : [contact.rolle].filter(Boolean);
      setSelectedRoles(roles);
    } else {
      setFormData({
        navn: '',
        email: '',
        telefon: '',
        sprogcenter_id: defaultScId
      });
      setSelectedRoles([]);
    }
  }, [contact, user, defaultScId, isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  // Håndter check/uncheck af roller
  const toggleRole = (role) => {
    setSelectedRoles(prev => {
      if (prev.includes(role)) {
        return prev.filter(r => r !== role); // Fjern
      } else {
        return [...prev, role]; // Tilføj
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (user.role === ROLES.ADMIN && !formData.sprogcenter_id) {
      alert('Vælg venligst et sprogcenter');
      return;
    }
    if (selectedRoles.length === 0) {
      alert('Vælg mindst én rolle');
      return;
    }

    // Vi sender rollerne som et array
    onSave({ 
      ...formData, 
      rolle: selectedRoles, 
      id: contact?.id 
    });
  };

  const handleDeleteClick = () => {
    if (window.confirm(`Er du sikker på at du vil slette ${formData.navn}?`)) {
      onDelete(contact.id);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        
        <div className="modal-header">
          <h2 className="modal-title">{contact ? 'Rediger Kontakt' : 'Opret Ny Kontakt'}</h2>
          <button className="close-btn" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          
          {user.role === ROLES.ADMIN && (
            <div className="form-group">
              <label>Tilhører Sprogcenter</label>
              <select 
                name="sprogcenter_id" 
                value={formData.sprogcenter_id} 
                onChange={handleChange}
                style={{border: '2px solid #003366', background: '#f0f4f8'}}
              >
                <option value="">-- Vælg Sprogcenter --</option>
                {centers.map(sc => (
                  <option key={sc.id} value={sc.id}>{sc.navn}</option>
                ))}
              </select>
            </div>
          )}

          <div className="form-group">
            <label>Navn</label>
            <input name="navn" value={formData.navn} onChange={handleChange} required placeholder="F.eks. Jens Jensen" />
          </div>

          <div className="form-group">
            <label>Email</label>
            <input type="email" name="email" value={formData.email} onChange={handleChange} required placeholder="mail@skole.dk" />
          </div>

          <div className="form-group">
            <label>Telefon</label>
            <input name="telefon" value={formData.telefon} onChange={handleChange} placeholder="12 34 56 78" />
          </div>

          {/* NYT: MULTI-SELECT ROLLER */}
          <div className="form-group">
            <label>Roller (Vælg en eller flere)</label>
            <div style={{
                display: 'flex', 
                flexWrap: 'wrap', 
                gap: '10px', 
                background: '#f9f9f9', 
                padding: '15px', 
                borderRadius: '8px', 
                border: '1px solid #ddd'
            }}>
                {AVAILABLE_ROLES.map(role => {
                    const isSelected = selectedRoles.includes(role);
                    return (
                        <label 
                            key={role} 
                            style={{
                                display: 'flex', 
                                alignItems: 'center', 
                                gap: '6px',
                                cursor: 'pointer',
                                userSelect: 'none',
                                background: isSelected ? '#e3f2fd' : 'white',
                                padding: '6px 10px',
                                borderRadius: '20px',
                                border: isSelected ? '1px solid #2196f3' : '1px solid #ccc',
                                fontSize: '0.85rem',
                                color: isSelected ? '#0d47a1' : '#555',
                                transition: 'all 0.2s'
                            }}
                        >
                            <input 
                                type="checkbox" 
                                checked={isSelected}
                                onChange={() => toggleRole(role)}
                                style={{display: 'none'}} // Skjul den grimme checkbox, brug styling på label
                            />
                            {isSelected ? '✓ ' : ''}{role}
                        </label>
                    );
                })}
            </div>
          </div>

          <div className="modal-footer">
            {contact ? (
              <button type="button" className="btn-delete" onClick={handleDeleteClick}>Slet</button>
            ) : <div></div>}

            <div className="modal-actions">
              <button type="button" className="btn-cancel" onClick={onClose}>Annuller</button>
              <button type="submit" className="btn-save">{contact ? 'Gem Ændringer' : 'Opret Kontakt'}</button>
            </div>
          </div>

        </form>
      </div>
    </div>
  );
};

export default ContactModal;